
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { BoxType } from "@/store/modules/BoxInfoModule";
import { BoxCategoryOption } from "@/store/modules/BoxCategoryModule";
import SimulationModal from "./SimulationModal.vue";

export default defineComponent({
  components: {
    SimulationModal,
  },
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("套系列表", ["套系管理;box_infos"]);
    });

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const tableData = ref([]);

    // 从 query params 恢复筛选条件
    const formData = ref({
      box_category_id: route.query.box_category_id ? Number(route.query.box_category_id) : "",
      box_type: (route.query.box_type as string) || "",
      game_type: (route.query.game_type as string) || "",
      name: (route.query.name as string) || "",
      is_crash: route.query.is_crash !== undefined ? route.query.is_crash === "true" : "",
      is_increase_membership_point: route.query.is_increase_membership_point !== undefined ? route.query.is_increase_membership_point === "true" : "",
      enabled: route.query.enabled !== undefined ? route.query.enabled === "true" : "",
    });

    // 从 query params 恢复分页
    const page = ref({
      currentPage: route.query.page ? Number(route.query.page) : 1,
      pageSize: route.query.pageSize ? Number(route.query.pageSize) : 10,
      totalResult: 0,
    });

    // 同步状态到 URL query params（replace 不产生历史记录）
    const syncQuery = () => {
      const q: Record<string, string> = {};
      if (page.value.currentPage > 1) q.page = String(page.value.currentPage);
      if (page.value.pageSize !== 10) q.pageSize = String(page.value.pageSize);
      if (formData.value.box_category_id) q.box_category_id = String(formData.value.box_category_id);
      if (formData.value.box_type) q.box_type = formData.value.box_type;
      if (formData.value.game_type) q.game_type = formData.value.game_type;
      if (formData.value.name) q.name = formData.value.name;
      if (formData.value.is_crash === true || formData.value.is_crash === false) q.is_crash = String(formData.value.is_crash);
      if (formData.value.is_increase_membership_point === true || formData.value.is_increase_membership_point === false) q.is_increase_membership_point = String(formData.value.is_increase_membership_point);
      if (formData.value.enabled === true || formData.value.enabled === false) q.enabled = String(formData.value.enabled);
      router.replace({ query: q });
    };

    // 模拟弹窗
    const simulationVisible = ref(false);
    const simulationBoxInfo = ref(null as any);

    const openSimulation = (row: any) => {
      simulationBoxInfo.value = row;
      simulationVisible.value = true;
    };

    const query = () => {
      syncQuery();
      store
        .dispatch(Actions.GET_BOX_INFOS, {
          ...formData.value,
          ...page.value,
        })
        .then(() => {
          tableData.value = store.getters.currentBoxInfos;
          page.value.totalResult = store.getters.currentBoxInfoCount;
        })
        .catch((e) => e);
    };

    query();

    const submitEvent = () => {
      page.value.currentPage = 1;
      query();
    };

    const newBoxInfo = () => {
      router.push({ name: "box_info_new" });
    };

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage;
      page.value.pageSize = e.pageSize;
      query();
    };

    const onCancel = () => {
      formData.value.box_category_id = "";
      formData.value.box_type = "";
      formData.value.game_type = "";
      formData.value.name = "";
      formData.value.is_crash = "";
      formData.value.is_increase_membership_point = "";
      formData.value.enabled = "";
      page.value.currentPage = 1;
      query();
    };

    const box_types = ref(Array<BoxType>());

    store
      .dispatch(Actions.GET_BOX_TYPES)
      .then(() => {
        box_types.value = store.getters.currentBoxTypes;
      })
      .catch((e) => e);

    const box_categories = ref(Array<BoxCategoryOption>());

    store
      .dispatch(Actions.GET_BOX_CATEGORIES)
      .then(() => {
        box_categories.value = store.getters.currentBoxCategories;
      })
      .catch((e) => e);

    const game_types = ref(Array<BoxType>());

    store
      .dispatch(Actions.GET_GAME_TYPES)
      .then(() => {
        game_types.value = store.getters.currentGameTypes;
      })
      .catch((e) => e);

    const formatPrice = (price: number | string | null | undefined): string => {
      if (price === null || price === undefined) return "0.0";
      const num = Number(price);
      return isNaN(num) ? "0.0" : num.toFixed(1);
    };

    const getGameTypeTag = (gameType: string) => {
      const map: Record<string, string> = {
        normal: "",
        infinity: "success",
        card: "warning",
        level: "info",
      };
      return map[gameType] || "";
    };

    const getBoxTypeTag = (boxType: string) => {
      const map: Record<string, string> = {
        cash: "success",
        membership_point: "warning",
        event_point: "info",
        extra_point: "danger",
      };
      return map[boxType] || "";
    };

    const getProfitColor = (profitAmount: number) => {
      if (profitAmount > 0) return "#67C23A";
      if (profitAmount < 0) return "#F56C6C";
      return "";
    };

    return {
      tableData,
      formData,
      submitEvent,
      newBoxInfo,
      page,
      onPageChange,
      onCancel,
      box_types,
      box_categories,
      game_types,
      formatPrice,
      getGameTypeTag,
      getBoxTypeTag,
      getProfitColor,
      simulationVisible,
      simulationBoxInfo,
      openSimulation,
    };
  },
});
